exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/admin/admin-products/admin-products.component.css
// module id = ../../../../../src/app/admin/admin-products/admin-products.component.css
// module chunks = 1